import {
  ReportType,
  ScoringForDirectReportsResponse,
  SettingsPeriod,
  DirectReportQuotaData
} from "@/entities/reporting/types";
import { UserData } from "@/entities/users/types";
import { ScoringTableDataRow } from "@/components/controls/DataTable/ScoringTable";
import { createScoringTableContext } from "@/components/layouts/ScoringTableCard/BaseScoringTableContext";

const { ScoringTableProvider } = createScoringTableContext();

const transformQuotaResponse = (
  data: ScoringForDirectReportsResponse
): ScoringTableDataRow[] => {
  const quotaData = data.quotaAchievement?.data
    .directReports as DirectReportQuotaData[];
  if (!quotaData) return [];

  return quotaData.map((scoringData: DirectReportQuotaData) => ({
    user: { id: scoringData.id } as UserData,
    summaryValue: scoringData.quotaAchievement,
    scoreIndicator: [
      scoringData.directReportsNum,
      scoringData.arrMrrForPeriod,
      0
    ]
  }));
};

export const QuotaAchievementProvider: React.FC<{
  children: React.ReactNode;
  leadUser: UserData | undefined;
  period?: SettingsPeriod;
}> = ({ children, leadUser }) => (
  <ScoringTableProvider
    leadUser={leadUser}
    reportType={ReportType.QUOTA_ACHIEVEMENT}
    defaultPeriod={undefined}
    transformResponse={transformQuotaResponse}
  >
    {children}
  </ScoringTableProvider>
);
